/* eslint-disable */
require('./clear-day')
require('./clear-night')
require('./cloudy')
require('./fog')
require('./hail')
require('./partly-cloudy-day')
require('./partly-cloudy-night')
require('./rain')
require('./sleet')
require('./snow')
require('./thunderstorm')
require('./tornado')
